export const extractDomainFromEmail = (email?: string) => {
  if (!email) {
    return "Unknown";
  }

  const afterAt = email.split("@")[1]; //virtualpricingdirector.com

  const dotIndex = afterAt.indexOf(".");

  const extractedBeforeDot = afterAt.substring(0, dotIndex);

  return extractedBeforeDot;
};
